import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { isChunkLoadError, reloadOnceForStaleChunks } from "@/lib/chunk-recovery";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <>
      <Outlet />
      <Toaster position="top-center" richColors />
    </>
  ),
  errorComponent: ({ error }) => {
    if (isChunkLoadError(error) && reloadOnceForStaleChunks("route-error")) return null;
    return (
      <main className="grid min-h-svh place-items-center bg-a1-black p-6 text-center text-white">
        <div>
          <h1 className="font-display text-3xl italic">Something went wrong.</h1>
          <p className="mt-2 text-sm text-white/70">Please reload the page. If it keeps happening, contact us.</p>
        </div>
      </main>
    );
  },
  notFoundComponent: () => (
    <main className="grid min-h-svh place-items-center bg-a1-black p-6 text-center text-white">
      <h1 className="font-display text-3xl italic">Page not found.</h1>
    </main>
  ),
});
